import * as React from 'react';
import { useState } from 'react';
import { Link} from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Spinner,Dropdown } from "react-bootstrap";
import Select from "react-select";
import {formatAreaFromKm} from "../utils/functions";
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import ScenarioSwitch from "../components/ScenarioSwitch";

import { PencilSimple, DotsThreeVertical,UserCircleDashed,Copy,DownloadSimple, Swap, Trash,BookOpen } from "@phosphor-icons/react";

class PanelProject extends React.Component {
	//	scenario
	//	project
	//	scenarios
	//	selectedScenario
	//	onSelectScenario
	//	onDelete
	//	onSave
	//	onDuplicate
	
	
	constructor(props) {
		super(props);
		
		this.state ={
			uploadLayer:{open:false, onUpload:this.handleBoundaryUpload}
		}
	}
	

	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	
	handleChangeScenario(e){
		this.props.onSelectScenario(e);
		//this.forceUpdate();

	}
	handleDeleteScenario(e){
		this.props.onDelete(e);

	}
	handleDuplicateScenario(e){
		this.props.onDuplicate(e);

	}
	handleRequestLandowners(e){
		this.props.onRequestLandOwners(e);

	}
	handleSaveScenario(e, rename){
		this.props.onSave(e, rename);

	}
	handleDownload(e){
		this.props.onDownload(e);

	}
	handleSetMain(e){
		this.props.onSetMain(e);

	}
	handleTerminate(e){
		this.props.onTerminate(e);

	}
	handleViewVersions(e){
		this.props.onVersions(e);

	}
	handleNotes(e){
		this.props.onViewNotes(e);

	}
	handleClose(e){
		
		if(this.props.hasChanges){
			e.preventDefault();
			this.props.onClose(()=>{window.location.href=e.target.parentNode.href});
		}

	}
	handleBoundaryUpload(layer){
		if(this.props.onReplace)
			this.props.onReplace(layer);

	}
	handleBoundaryUploadRoads(layer){
		if(this.props.onReplaceRoads)
			this.props.onReplaceRoads(layer);

	}
	handleBoundaryUploadPowerlines(layer){
		if(this.props.onReplacePowerlines)
			this.props.onReplacePowerlines(layer);

	}
	handleBoundaryUploadTurbines(layer){
		if(this.props.onReplaceTurbines)
			this.props.onReplaceTurbines(layer);

	}
	
	render(){
		if(this.props.project && this.props.scenario) {
			return (
				<>
					<div className="nav-group project-panel pb-0 show">
						<div className="scenario">
							<Select 
								value={this.props.selectedScenario} 
								classNames={{
									control: ()=>'select-scenario-control', 
									valueContainer: ()=>'select-scenario-container', 
									singleValue: ()=>'select-scenario-value',
									menuList:()=>"select-scenario-list",
									option:()=>"select-scenario-option",
									dropdownIndicator: ()=> "select-scenario-dropdown",
									indicatorSeparator: ()=> "select-scenario-separator"
								}} 
								options={this.props.scenarios} 
								onChange={(e)=>{this.handleChangeScenario(e);}}  
								isSearchable={false} 
							/>
							<Dropdown className="scenario-context">
								<Dropdown.Toggle variant="outline-primary"><DotsThreeVertical size={16} /></Dropdown.Toggle>
								<Dropdown.Menu>
									{/*<Dropdown.Item href="#" onClick={(e)=>{this.handleRequestLandowners(e);}} className="important"><UserCircleDashed size={14} /> Request Land Owners</Dropdown.Item>*/}
									<Dropdown.Item href="#" onClick={(e)=>{this.handleDuplicateScenario(e);}} className="details"><Copy  weight="bold" size={14} /> Duplicate</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.handleSetMain(e);}} disabled={!this.props.scenario || !this.props.scenario.scenario_id || !this.props.user.userDetails || this.props.versionid || this.props.hasChanges}  className="details"><PencilSimple weight="bold" size={14} /> Set as Main</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.handleViewVersions(e);}} disabled={this.props.versionid} className="details"><BookOpen weight="bold" size={16} /> Versions</Dropdown.Item> 
									<Dropdown.Item href="#" onClick={(e)=>{this.handleSaveScenario(e, true);}} disabled={!this.props.scenario || !this.props.scenario.scenario_id } className="important"><PencilSimple weight="bold" size={14} /> Edit scenario</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.handleDownload(e);}} disabled={!this.props.scenario} className="important"><DownloadSimple weight="bold" size={14} /> Download</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.updateStatus({uploadLayer:{open:true, title:'Upload boundary', onUpload:this.handleBoundaryUpload}})}} disabled={!this.props.scenario || !this.props.scenario.scenario_id} className="important"><Swap weight="bold" size={14} /> Replace boundary</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.updateStatus({uploadLayer:{open:true, title:'Upload roads', onUpload:this.handleBoundaryUploadRoads}})}} disabled={!this.props.scenario || !this.props.scenario.scenario_id} className="important"><Swap weight="bold" size={14} /> Replace roads</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.updateStatus({uploadLayer:{open:true, title:'Upload powerlines', onUpload:this.handleBoundaryUploadPowerlines}})}} disabled={!this.props.scenario || !this.props.scenario.scenario_id} className="important"><Swap weight="bold" size={14} /> Replace powerlines</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.updateStatus({uploadLayer:{open:true, title:'Upload turbines', onUpload:this.handleBoundaryUploadTurbines}})}} disabled={!this.props.scenario || !this.props.scenario.scenario_id} className="important"><Swap weight="bold" size={14} /> Replace turbines</Dropdown.Item>
									<Dropdown.Item href="#" onClick={(e)=>{this.handleDeleteScenario(e);}} disabled={!this.props.scenario || !this.props.scenario.scenario_id || this.props.versionid} className="share text-danger"><Trash  weight="bold" size={14} /> Delete</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>
					<ScenarioSwitch open={true} scenarios={this.props.project.scenarios} />
					<DialogUploadLayer setup={this.state.uploadLayer} title={this.state.uploadLayer.title} type="convertLayer" onUpload={this.state.uploadLayer.onUpload.bind(this)} onClose={()=>{this.updateStatus({uploadLayer:{open:false, onUpload:this.handleBoundaryUpload}});}} />
				</>
			)
		}
		return;
	}
} 
export default PanelProject;